export const GOOGLE_SIGNIN_START = "GOOGLE_SIGNIN_START";
export const EMAIL_SIGNIN_START = "EMAIL_SIGNIN_START";

export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS";
export const SIGNIN_FAIL = "SIGNIN_FAIL";

export const CHECK_USER_SESSION = "CHECK_USER_SESSION";

export const SIGNOUT_REQUEST = "SIGNOUT_REQUEST";
export const SIGNOUT_SUCCESS = "SIGNOUT_SUCCESS";
export const SIGNOUT_FAIL = "SIGNOUT_FAIL";

export const SIGNUP_REQUEST = "SIGNUP_REQUEST";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAIL = "SIGNUP_FAIL";
